<template>
  <div class="horizontal-stepper">
    <div
      v-for="(step, index) in stepper"
      :key="index"
      class="horizontal-stepper__block"
    >
      <span :class="`stepper__step--${step.stepColor}`" :title="step.title" />
      <span
        v-if="!isLastStep(index)"
        class="horizontal-stepper__line"
        :class="`horizontal-stepper__line--${step.lineColor}`"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stepper: { type: Array, default: () => [] },
  },
  methods: {
    isLastStep(step) {
      return step === this.stepper.length - 1;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@styles/components/horizontal-stepper-common';
</style>
